import { Link } from 'react-router-dom';

export default function InnerFooter() {
  return (
    <footer className="bg-navy border-t border-navy">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src="https://qymceftywmiiwdrmhnwb.supabase.co/storage/v1/object/public/files/evernorth-ai/default%20logo%20white.svg"
              alt="Evernorth AI Logo"
              className="h-12 w-auto mb-4"
            />
            <p className="text-white/60 text-sm leading-relaxed mb-6">
              Helping Northwest Georgia businesses future-proof their offices through customized AI training, workshops, and ongoing support.
            </p>
            <div className="flex gap-3">
              <a href="https://www.facebook.com/people/Evernorth-AI/61584730084444/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-gold transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-white"></i>
              </a>
              <a href="https://x.com/EvernorthAI" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-gold transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-white"></i>
              </a>
              <a href="https://www.linkedin.com/company/evernorthai/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-gold transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-white"></i>
              </a>
              <a href="https://www.youtube.com/@Evernorth_AI" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-gold transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-white"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/60 hover:text-gold transition-colors text-sm cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/60 hover:text-gold transition-colors text-sm cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/faqs" className="text-white/60 hover:text-gold transition-colors text-sm cursor-pointer">
                  FAQs
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/60 hover:text-gold transition-colors text-sm cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">Services</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-white/60 hover:text-gold transition-colors text-sm cursor-pointer flex items-center gap-1.5">
                  All Services
                </Link>
              </li>
              <li>
                <Link to="/workshops/half-day" className="text-white/60 hover:text-gold transition-colors text-sm cursor-pointer flex items-center gap-1.5">
                  Half Day Workshop
                </Link>
              </li>
              <li>
                <Link to="/workshops/full-day" className="text-white/60 hover:text-gold transition-colors text-sm cursor-pointer flex items-center gap-1.5">
                  Full Day Workshop
                </Link>
              </li>
              <li>
                <Link to="/service-areas" className="text-white/60 hover:text-gold transition-colors text-sm cursor-pointer">
                  Service Areas
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="text-white/60 text-sm">Northwest Georgia</li>
              <li className="text-white/60 text-sm">info@evernorthai.com</li>
              <li className="text-white/60 text-sm">706-331-5858</li>
              <li className="text-white/60 text-sm">Mon-Fri: 9:00 AM - 5:00 PM (EST)</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/40 text-sm">
              &copy; 2026 Evernorth AI. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy-policy" className="text-white/40 hover:text-gold text-sm transition-colors cursor-pointer">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="text-white/40 hover:text-gold text-sm transition-colors cursor-pointer">
                Terms of Service
              </Link>
              <a href="https://vikingone5.com/" target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-gold text-sm transition-colors cursor-pointer">
                Website Built by VikingOne5 Media
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
